export const MetaTags = () => {
  return <meta name="format-detection" content="telephone=no" />;
};
